import { render, staticRenderFns } from "./entity-property-cross-reference.vue?vue&type=template&id=41898470&"
import script from "./entity-property-cross-reference.vue?vue&type=script&lang=js&"
export * from "./entity-property-cross-reference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports